import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useState } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import axiosService from '../../../../../utils/AxiosService'
import ReactMultiSelect from '../../../../FormComponents/ReactMultiSelect'

export default observer(function AudienceCityFilter() {
  const { search } = useContext(SearchContext)

  const [audienceCityOptions, setAudienceCityOptions] = useState([])

  useEffect(() => getAudienceCityOptions(), [])

  const getAudienceCityOptions = () => {
    axiosService.get(`/api/project_manager/authentications/audience_cities`)
    .then(cities => setAudienceCityOptions(cities.map((city) => ({ label: city.name, value: city.id }))))
  }

  const setAudienceCityFilter = (cities) => {
    search.audience_cities = cities.map(city => city.value)
    search.selectedAudienceCities = cities
    search.order = cities.length ? 'audience_cities' : 'reach'
  }

  return (
    <div className="w-full">
      <ReactMultiSelect
        placeholder="Any city"
        name="filter"
        onChange={setAudienceCityFilter}
        options={audienceCityOptions}
        value={search.selectedAudienceCities}
        disableSearch
        hasSelectAll={false}
      />
    </div>
  )
})